export var InventoryReceiptType;
(function (InventoryReceiptType) {
    InventoryReceiptType["Originator"] = "Originator";
    InventoryReceiptType["Receiver"] = "Receiver";
})(InventoryReceiptType || (InventoryReceiptType = {}));
//# sourceMappingURL=InventoryReceiptType.js.map